import React from 'react'
import './Plan_Compare_Page.css'
import Plan_Cards_Component from './Plan_Cards_Component/Plan_Cards_Component'
import Plan_Information_Component from './Plan_Information_Component/Plan_Information_Component'
import { useLocation } from 'react-router-dom';
const Plan_Compare_Page = () => {
    const location = useLocation();
    const selectedPlans = location.state?.selectedPlans || [];
    const insuranceData = location.state?.insuranceData || [];
    const data = location.state?.data || [];
    console.log(selectedPlans,'selectedPlans');
    
    return (
        <section className='Plan_Compare_Page'>
            <div className='container'>
                <div className='light_orange_div'>
                    <div className='three_divs_holder'>
                        <div className='live_cover_div common_div'>
                            <p className='text'>{selectedPlans[0]?.life_cover}</p>
                        </div>

                        <div className='cover_upto_div common_div'>
                            <p className='text'>{selectedPlans[0]?.cover_till_age}</p>
                        </div>

                        <div className='last_div common_div'>
                            <p className='text'>Regular Pay</p>
                        </div>
                    </div>
                </div>

                <div className='plan_card_main_div'>
                    <Plan_Cards_Component selectedPlansdata={selectedPlans} insuranceData={insuranceData}/>
                </div>


                <Plan_Information_Component selectedPlansdata={selectedPlans}/>

            </div>
        </section>
    )
}

export default Plan_Compare_Page
